import { colors as tailwindColors } from '../../../tailwind.config';

type ColorNames = keyof typeof tailwindColors;

type ColorsMap = Uppercase<`${ColorNames}_${keyof (typeof tailwindColors)[ColorNames]}`>;
type ColorValues = (typeof tailwindColors)[ColorNames][keyof (typeof tailwindColors)[ColorNames]];

export const COLORS = Object.entries(tailwindColors).reduce(
  (acc, [key, shades]) => {
    Object.entries(shades).forEach(([shade, value]) => {
      const colorKey = `${key.toUpperCase()}_${shade}`;
      acc[colorKey as ColorsMap] = value as ColorValues;
    });
    return acc;
  },
  {} as Record<ColorsMap, ColorValues>,
);
